import { render, staticRenderFns } from "./oiorderSearch.vue?vue&type=template&id=6b5779b8&scoped=true"
import script from "./oiorderSearch.vue?vue&type=script&lang=js"
export * from "./oiorderSearch.vue?vue&type=script&lang=js"
import style0 from "./oiorderSearch.vue?vue&type=style&index=0&id=6b5779b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5779b8",
  null
  
)

export default component.exports